/**
 * Admin API Helper - Talk Australia Portal
 * JWT auth, auto-refresh, role-aware utilities
 */

const API_BASE = process.env.REACT_APP_API_URL || '';

export function getAdminToken() {
  return localStorage.getItem('ta_admin_token') || '';
}

export function getAdminData() {
  try {
    return JSON.parse(localStorage.getItem('ta_admin_data') || 'null');
  } catch { return null; }
}

export function setAdminTokens(token, refreshToken, adminData) {
  localStorage.setItem('ta_admin_token', token);
  localStorage.setItem('ta_admin_refresh', refreshToken);
  localStorage.setItem('ta_admin_data', JSON.stringify(adminData));
}

export function clearAdminTokens() {
  localStorage.removeItem('ta_admin_token');
  localStorage.removeItem('ta_admin_refresh');
  localStorage.removeItem('ta_admin_data');
}

export async function adminFetch(endpoint, options = {}) {
  const token = getAdminToken();
  const res = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  if (res.status === 401) {
    // Try refresh
    const refreshToken = localStorage.getItem('ta_admin_refresh');
    if (refreshToken) {
      try {
        const refreshRes = await fetch(`${API_BASE}/api/admin/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refreshToken }),
        });
        if (refreshRes.ok) {
          const data = await refreshRes.json();
          localStorage.setItem('ta_admin_token', data.token);
          // Retry original request
          return fetch(`${API_BASE}${endpoint}`, {
            ...options,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${data.token}`,
              ...(options.headers || {}),
            },
          });
        }
      } catch {}
    }
    // Refresh failed — redirect to login
    clearAdminTokens();
    window.location.href = '/admin/login';
    return res;
  }

  return res;
}

export function navigate(path) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function adminLogout() {
  clearAdminTokens();
  navigate('/admin/login');
}

/**
 * Check if current admin has permission
 */
export function hasPermission(resource, action) {
  const admin = getAdminData();
  if (!admin) return false;
  const perms = admin.permissions || {};
  if (!perms[resource]) return false;
  return perms[resource].includes(action);
}

export function isRole(...roles) {
  const admin = getAdminData();
  return admin && roles.includes(admin.role);
}
